<template lang="html">


<!-- AMPLIAR -->
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
    <path :fill="colors.basic"  d="M8.11 8.453v3.52h1.015v-3.02h2.849V7.939h-3.35a.524.524 0 0 0-.514.515zM3.97 8.44a.5.5 0 0 0-.502-.502H0v1.016h2.954v3.006h1.015V8.44zm4.14-5.13a.5.5 0 0 0 .501.5h3.363V2.797H9.125V.013H8.11V3.31zm-4.642.488H0V2.782h2.967V0h1.015v3.283a.524.524 0 0 1-.514.515z"/>
</svg>




</template>

<script lang="js">
  
  import {mapGetters} from 'vuex';

  export default  {
    name: 'add',
    props: [],
    computed : {
      ...mapGetters({
        colors : 'basicColors'
      })
    }
}
</script>

<style scoped lang="scss">
  .add {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/minificar.vue